import { compose } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import * as Actions from '../../actions/SeminarRegisteredManagermentViewer';
import { GetDetailSeminarRequested, ClearDetailSeminar } from '../../actions/SeminarManagementOrganizer';
import withAuth from '../../common/WithAuth';
import DetailSeminarRegistered, { Header } from '../../pages/SeminarRegisteredManagermentViewer/DetailSeminarRegistered';
import { getSettingCustomTextRequested, getSettingCustomTextClear } from '../../actions/AdminSettingCustom';

const mapStateToProps = (state) => ({
    detailSeminar: _.isEmpty(state.seminarRegisteredManagermentViewer.detailSeminarRegistered.data)
        ? state.seminarManagementOrganizer.detailSeminar.data
        : state.seminarRegisteredManagermentViewer.detailSeminarRegistered.data,
    locale: state.locale.lang.current,
    eventInfo: state.registration.registrationViewer.data,
    token: state.auth.credential.data.token,
    customText: state.adminSettingCustom.getCustomText.data?.content,
    customColorSeminar: state.registrationOrganizer.registrationOrganizer.data?.settings_colors_viewer,
});

const mapDispatchToProps = (dispatch) => ({
    fetchDetailSeminarRegistered: (params) => {
        dispatch(Actions.GetDetailSeminarRegisteredRequested(params));
    },
    clearData: () => {
        dispatch(Actions.ClearDetailSeminarRegistered());
    },
    getDetailSeminar: (params) => {
        dispatch(GetDetailSeminarRequested(params));
    },
    clearDetailSeminar: () => {
        dispatch(ClearDetailSeminar());
    },
    getCustomText: (params) => {
        dispatch(getSettingCustomTextRequested(params));
    },
    clearCustomText: () => {
        dispatch(getSettingCustomTextClear());
    },
});

export const DetailSeminarRegisteredHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(DetailSeminarRegistered);
